import { createContext, type Dispatch, type SetStateAction } from 'react';

const BuyBingoBallsContext = createContext(
  {} as {
    activeOfferIndex: number;
    setActiveOfferIndex: Dispatch<SetStateAction<number>>;
    source?: 'plus_button' | 'no_balance_modal';
  },
);

export { BuyBingoBallsContext };
